import React, { forwardRef }                 from 'react';
import { createStyles, Group, Select, Text } from '@mantine/core';
import { FormFieldType }                     from '@core/components/form/skin-active/form-field-type';
import { IconFlag }                          from '@tabler/icons';
import { CountriesList }                     from '@core/data/countries-list';


const useStyles = createStyles((
    theme: {
        colors: { [x: string]: any[] };
        colorScheme: string;
        fn: any;
        fontSizes: any;
        spacing: any;
    }) => ({

    selectCountry: {
        position: 'relative',

        'input': {
            height: 'auto',
            paddingTop: 40,
            paddingBottom: 4,
            fontSize: 14,
        },

        '& .mantine-Input-icon': {
            top: 38,
            fontSize: 20,
        },

        'label': {
            position: 'absolute',
            pointerEvents: 'none',
            fontSize: theme.fontSizes.sm,
            paddingLeft: theme.spacing.sm,
            paddingTop: 20 / 2,
            zIndex: 1,
        },

        '& .mantine-Select-description': {
            position: 'absolute',
            pointerEvents: 'none',
            fontSize: theme.fontSizes.xs,
            paddingLeft: theme.spacing.sm,
            paddingTop: 28,
            zIndex: 1,
            color: theme.colorScheme === 'dark' ? theme.colors.dark[2] : theme.colors.gray[7],
        },

        '& .mantine-Select-input::placeholder': {
            color: theme.colorScheme === 'dark' ? theme.colors.dark[2] : theme.colors.gray[7],
        },

        '& .mantine-InputWrapper-error': {
            fontSize: 12,
            paddingTop: 6,
        },

    },

}));

interface ItemProps extends React.ComponentPropsWithoutRef<'div'> {
    label: string;
}

export const CountryField: React.FC<FormFieldType<any>> = ({
                                                               value,
                                                               variable,
                                                               form,
                                                               defaultValue,
                                                               errorMsg,
                                                               fieldLabel,
                                                               placeholder,
                                                               description,
                                                               inputVariant,
                                                               required,
                                                               disabled,
                                                               searchable,
                                                               clearable,
                                                               onChange
                                                           }) => {
    const { classes } = useStyles();

    const SelectItem = forwardRef<HTMLDivElement, ItemProps>(
        ({ label, ...others }: ItemProps, ref) => (
            <div ref={ref} {...others}>
                <Group noWrap={true}>
                    <div>
                        <Text size="sm">{label}</Text>
                    </div>
                </Group>
            </div>
        )
    );

    return (
        <Select
            className={classes.selectCountry}
            mt="sm"
            radius="xs"
            value={value}
            onChange={onChange}
            itemComponent={SelectItem}
            defaultValue={defaultValue}
            label={fieldLabel}
            placeholder={placeholder}
            description={description}
            error={errorMsg}
            required={required}
            disabled={disabled}
            variant={inputVariant}
            searchable={searchable}
            clearable={clearable}
            allowDeselect={true}
            nothingFound="No options"
            // rightSection={<IconChevronDown size={14} />}
            // rightSectionWidth={30}
            maxDropdownHeight={400}
            transition="pop-top-left"
            transitionDuration={80}
            transitionTimingFunction="ease"
            /*getCreateLabel={(query) => `+ Create ${query}`}
            onCreate={(query) => {
                const item = { value: query, label: query };
                setData((current) => [...current, item]);
                return item;
            }}*/
            data={
                CountriesList.map((country) => {

                    return {
                        label: country.label,
                        value: country.label
                    };
                })

            } //CountriesList
            icon={<IconFlag size={16} stroke={1}/>}
            /*filter={
                (value, item) => {
                    return item.label.toLowerCase().includes(value.toLowerCase().trim());
                }

            }*/

            {...form.getInputProps(variable)}
        />
    );
};
